import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { environment } from "src/environments/environment";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AMDService {
  private resetSearchSubject = new Subject<void>(); 
  
  get resetSearch$() {
    return this.resetSearchSubject.asObservable();
  }

  triggerReset() {
    this.resetSearchSubject.next();
  }
  getAssetListbyBeCategory(userId: any, workGroupId: any, beCategoryId: any) {
    throw new Error('Method not implemented.');
  }
  getAssetListbyLocation(userId: any, stateId: any, districtId: any, clinicCategoryId: any, clinicTypeId: any, circleId: any, clinicId: any) {
    throw new Error('Method not implemented.');
  }
  constructor(public http: HttpClient) { }

  serviceApiUrl: string = environment.serviceApiUrl;

  currentUser: any = JSON.parse(sessionStorage.getItem('currentUser'));
  userDetails: any = this.currentUser?.userDetails[0];
// Supplier
  fetchAllSupplier() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "supplierController/all");
  }
  public approveSupplier(data) {
    return this.http.put(this.serviceApiUrl + 'supplierController/approve-supplier', data);
  }
  saveSupplier(data) {
    return this.http.post(this.serviceApiUrl + "supplierController/add", data);
  }
  updateSupplierWithFile(data, file) {
    const formData: FormData = new FormData();
    formData.append("supplier", JSON.stringify(data));
    formData.append("File", file);
    const req = new HttpRequest(
      "POST",
      `${this.serviceApiUrl}supplierController/updateWithFile`,
      formData,
      {
        reportProgress: true,
        responseType: "json",
      }
    );
    return this.http.request(req);
  }
  updateSupplier(data) {
    return this.http.put(this.serviceApiUrl + "supplierController/update",data);
  }
  updateEditVerified(data){
    return this.http.put(this.serviceApiUrl + "supplierController/addnew",data);
  }
  getSupplierCode(code) { return this.http.get(this.serviceApiUrl + "supplierController/generateCode?code=" + code);
  }

  fetchByProvisionalScheduleMaintenanceplanpreview(stateId){
    return this.http.get(this.serviceApiUrl + "scheduleMaintenanceTe/smPlan?stateId=" +stateId);
  }
  fetchByProvisionalScheduleMaintenanceplanpreviewLe(stateId){
    return this.http.get(this.serviceApiUrl + "scheduleMaintenanceLe/smPlan?stateId=" +stateId);
  }

// ManufacturerandModel
fetchAllbeCodeAndManufacturer() {return this.http.get<Observable<any>>(this.serviceApiUrl + "beCodeAndManufacturer/all");
}
fetchAccessoriesAdd(data:any) {
  return this.http.post(this.serviceApiUrl + "mAssetAccessories/addAssetAccessories",data);

}
fetchDeactiveBeInfo(accessoriesBeNumber) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "mAssetAccessories/deActivateAccessories?accessoriesBeNumber="+accessoriesBeNumber+'&flag=N');
}

public approveManufacturerModel(data) {
  return this.http.put(this.serviceApiUrl + 'beCodeAndManufacturer/approve-becodeandmanufacturer', data);
}
fetchAllbeCodeAndManufacturerTableData() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "beCodeAndManufacturer/findallgroupByManufacturerCategoryAndBeCode");
}
savebeCodeAndManufacturer(data) {
  return this.http.post(this.serviceApiUrl + "beCodeAndManufacturer/add",data);
}

saveAllThePoAndSupplierDetail(data){
  return this.http.post(this.serviceApiUrl + "poAndSupplier/addAll",data);
}

updateAllThePoAndSupplierDetail(data){
  return this.http.post(this.serviceApiUrl + "poAndSupplier/updateAll",data);
}

fetchByBeCodeManufacturerId(becodeManufacturerId){
  return this.http.get(this.serviceApiUrl + "poAndSupplier/fetchByBeCodeManufacturerId?beCodeManufacturerId="+becodeManufacturerId);
}

updatebeCodeAndManufacturerWithFile(data, file) {
  // return this.http.put(
  //   this.serviceApiUrl + "beCodeAndManufacturer/update",
  //   data
  // );
  const formData: FormData = new FormData();
  formData.append("bECodeAndManufacturer", JSON.stringify(data));
  formData.append("File", file);
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}beCodeAndManufacturer/newUpdateWithFile`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
updatebeCodeAndManufacturer(data) {
  return this.http.put(this.serviceApiUrl + "beCodeAndManufacturer/update",data);
}
// ModelNumber
fetchAllModelnumber() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "m_model_number/all");
}

// Manufacturer
fetchAllManufacture() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "m_manufacturer/all");
}
public approveManufacturer(data) {
  return this.http.put(this.serviceApiUrl + 'm_manufacturer/approve-manufacturer', data);
}
saveManufactureItem(data) {
  return this.http.post(this.serviceApiUrl + "m_manufacturer/add", data);
}
updateManufactureItem(data) {
  return this.http.put(this.serviceApiUrl + "m_manufacturer/update", data);
}

updateManufactureItemWithFile(data, file) {
  const formData: FormData = new FormData();
  formData.append("manufacturer", JSON.stringify(data));
  formData.append("File", file);
  // return this.http.put(this.serviceApiUrl + 'm_manufacturer/updateWithFile',data);
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}/m_manufacturer/updateWithFile`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
getCodeManufacturer(code: String) {
  return this.http.get(this.serviceApiUrl + "m_manufacturer/generateCode?code=" + code);
}
// Test Equipment
fetchAllTestCreation() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "testCreation/all");
}
fetchAllTestEquipment() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "beCodeAndTeCode/all");
}
saveTestEquipment(data) {
  return this.http.post(this.serviceApiUrl + "beCodeAndTeCode/add", data);
}
updateTestEquipment(data) {
  return this.http.put(this.serviceApiUrl + "beCodeAndTeCode/update", data);
}
public approveTeList(data) {
   return this.http.put(this.serviceApiUrl + 'teList/approve', data);
}
fetchByTeCode(teCode) {
  return this.http.get(this.serviceApiUrl + "tecode/fetchByTeCode?teCode=" + teCode);
}
fetchByAssetCategoryIdInTestEquipmentCategory(testCreationId) {
  return this.http.get<Observable<any>>(
    // this.serviceApiUrl + "testEquipmentCategory/fetchByAssetCategoryId?assetCategoryId=" +assetCategoryId
    this.serviceApiUrl + "testEquipmentCategory/fetchByTestCreationId?testCreationId=" + testCreationId
  );
}
fetchAllTEList() {
  return this.http.get(this.serviceApiUrl + "teList/all");
}
saveTEList(data) {
  return this.http.post(this.serviceApiUrl + "teList/add", data);
}

updateTEList(data) {
  return this.http.put(this.serviceApiUrl + "teList/update", data);
}
getQubesTeCode(stateCode) {
  return this.http.get(this.serviceApiUrl + "teList/generateTeNumberQubes?code=" + stateCode + 'TE-')
}
fetchAllTECategory() {
  return this.http.get(this.serviceApiUrl + "teCategory/all");
}

saveTECategory(data) {
  return this.http.post(this.serviceApiUrl + "teCategory/add", data);
}

updateTECategory(data) {
  return this.http.put(this.serviceApiUrl + "teCategory/update", data);
}
fetchAllTeCreation() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "tecode/all");
}

fetchAllTeCreationOg() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "testCreation/all");
}
public approveTeCode(data) {
  return this.http.put(this.serviceApiUrl + 'tecode/approve', data);
}
getCodeTest() {
  return this.http.get(this.serviceApiUrl + "tecode/generateCode");
}
updateTest(data) {
  return this.http.put(this.serviceApiUrl + "tecode/update", data);
}

saveTest(data) {
  return this.http.post(this.serviceApiUrl + "tecode/add", data);
}
saveTeCreation(data) {
  // return this.http.post(this.serviceApiUrl + "testCreation/add", data);
  return this.http.post(this.serviceApiUrl + "tecode/add", data);

}
// Loan Equipment
 
fetchAllLoanEquipment() {
  return this.http.get<Observable<any>>( this.serviceApiUrl + "beCodeAndLeCode/all");
}
saveLoanEquipment(data) {
  return this.http.post(this.serviceApiUrl + "beCodeAndLeCode/add", data);
}
updateLoanEquipment(data) {
  return this.http.put(this.serviceApiUrl + "beCodeAndLeCode/update", data);
}
fetchAllLeCodeLeList() {
  return this.http.get(this.serviceApiUrl + "leCodeLeList/all");
}
public approveLeCode(data) {
  return this.http.put(this.serviceApiUrl + 'leCodeLeList/approve', data);
}
// Var-Process
denyForRejectVar2(data) {
  return this.http.put(this.serviceApiUrl + "var2/reject", data);
}
fetchVar2FilteredDatas(
  stateId,
  districtId,
  clinicCategoryId,
  variationPeriod,
  year
) {
  let data = "";

  if (stateId != null && stateId != "") {
    data += "stateId=" + stateId + "&";
  }
  if (districtId != null && districtId != "") {
    data += "districtId=" + districtId + "&";
  }
  if (clinicCategoryId != null && clinicCategoryId != "") {
    data += "clinicCategoryId=" + clinicCategoryId + "&";
  }
  if (variationPeriod != null && variationPeriod != "") {
    data += "variationPeriod=" + variationPeriod + "&";
  }
  if (year != null && year != "") {
    data += "year=" + year + "&";
  }
  console.log("datas passed", data);
  return this.http.get(
    this.serviceApiUrl + "var2/fetchGroupByFilterList?" + data
  );
}
fetchgroupByfilter(stateId){
  let urlString = "scheduleMaintenanceTe/all?stateId=" +stateId
  if (stateId != null && stateId != '') {
    urlString += "&circleId=" + stateId
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}

saveWorktimeClinic(data) {
  return this.http.post( this.serviceApiUrl + "working_date_and_time_for_clinic/add",data);
}
saveAllVar2(data, file) {
  const formData: FormData = new FormData();
  formData.append("varV1S1", JSON.stringify(data));
  formData.append("supportingDocument", file);
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}var2/updateStatus`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
  // console.log("service post;;;;;", data);
  // return this.http.put(this.serviceApiUrl + "var2/updateStatus", data);
}
public approvalProcessMail(email1, stateId, districtId, clinicCategoryId, variationPeriod, year, var2RefNumber, userId, serviceApiUrl) {
  return this.http.get(this.serviceApiUrl + 'MOHUser/approvalProcessMail?email1=' + email1 + '&stateId=' + stateId + '&districtId=' + districtId + '&clinicCategoryId=' + clinicCategoryId + '&variationPeriod=' + variationPeriod + '&year=' + year + '&var2RefNumber=' + var2RefNumber + '&userId=' + userId + '&serviceApiUrl=' + serviceApiUrl)
}
updateWorktimeClinic(data) {
  return this.http.put(this.serviceApiUrl + "working_date_and_time_for_clinic/update",data);
}
fetchMohUserDistrictLevel(level,districtId,clinicCategoryId){
  return this.http.get(this.serviceApiUrl + 'qubes-user/fetchMohDetailsToSendApprovalMail?level='+level+'&districtId=' + districtId + '&clinicCategoryId=' + clinicCategoryId)
}
public checkAnyPendingProcessOnAdditionTable(districtId, clinicCategoryId, period, year) {
  return this.http.get(this.serviceApiUrl + 'varV1S1/checkAnyPendingProcessOnAdditionTable?districtId=' + districtId + '&clinicCategoryId=' + clinicCategoryId + '&period=' + period + '&year=' + year);
}
public checkAnyPendingProcessOnOmissionTable(districtId, clinicCategoryId, period, year) {
  return this.http.get(this.serviceApiUrl + 'varV1S2/checkAnyPendingProcessOnOmissionTable?districtId=' + districtId + '&clinicCategoryId=' + clinicCategoryId + '&period=' + period + '&year=' + year);
}
fetchFilteredVar2Result(
  stateId,
  districtId,
  clinicCategoryId,
  variationPeriod,
  year,
  var2RefNo
) {

  if (var2RefNo != null && var2RefNo != "") {
    return this.http.get(
      this.serviceApiUrl +
      "var2/fetchFilteredVar2Result?stateId=" +
      stateId +
      "&districtId=" +
      districtId +
      "&clinicCategoryId=" +
      clinicCategoryId +
      "&variationPeriod=" +
      variationPeriod +
      "&year=" +
      year
      +
      "&var2RefNo=" +
      var2RefNo
    );
  } else {
    return this.http.get(
      this.serviceApiUrl +
      "var2/fetchFilteredVar2Result?stateId=" +
      stateId +
      "&districtId=" +
      districtId +
      "&clinicCategoryId=" +
      clinicCategoryId +
      "&variationPeriod=" +
      variationPeriod +
      "&year=" +
      year
      +
      "&var2RefNo=" +
      null
    );
  }
}
genrateVar2RefNumber(period, year) {
  return this.http.get(this.serviceApiUrl +"var2/generateRefNumber?period=" +period +"&year=" +year);
}
public mohUserDetails(data) {
  return this.http.get(this.serviceApiUrl + 'MOHUser/add', data);
}
fetchAllVar4FilterDatas() {
  return this.http.get(this.serviceApiUrl + "Var4and6/fetchVar4ByFilter");
}
// approveVar4OnVariation4(data, file) {
//   const formData: FormData = new FormData();
//   formData.append("var4RefNumber", JSON.stringify(data));
//   formData.append("supportingDocument", file);
//   const req = new HttpRequest(
//     "PUT",
//     `${this.serviceApiUrl}/Var4and6/updateStatusVariation4`,
//     formData,
//     {
//       reportProgress: true,
//       responseType: "json",
//     }
//   );
//   return this.http.request(req);
  
// }
approveVar4OnVariation4(data, file) {
  const formData: FormData = new FormData();
  formData.append("stringObject", JSON.stringify(data));
  formData.append("supportingDocument", file);
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}Var4and6/updateStatusVariation4`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
  
}
fetchAllVar4FilterDatasFromVariation4() {
  return this.http.get(this.serviceApiUrl + "Var4and6/fetchVar4ByFilterFromVariation4");
}
saveAllVar4(data) {
  return this.http.post(this.serviceApiUrl + "Var4and6/addVar4", data);
}
// fetchByDistrictAndClinicCategoryVar2(districtId, clinicCategoryId) {
//   return this.http.get(this.serviceApiUrl + "var2/fetchByDistrictAndClinicCategory?districtId=" + districtId + "&clinicCategoryId=" + clinicCategoryId);
// }
// fetchByDistrictAndClinicCategoryVar3(districtId, clinicCategoryId) {
//   return this.http.get(this.serviceApiUrl + "var3/fetchByDistrictAndClinicCategory?districtId=" + districtId + "&clinicCategoryId=" + clinicCategoryId);
// }
fetchByDistrictAndClinicCategoryVar2(districtId, clinicCategoryId, period, year) {
  return this.http.get(this.serviceApiUrl + "var2/fetchByDistrictAndClinicCategory?districtId=" + districtId + "&clinicCategoryId=" + clinicCategoryId + '&period=' + period + '&year=' + year);
}
fetchByDistrictAndClinicCategoryVar3(districtId, clinicCategoryId, period, year) {
  return this.http.get(this.serviceApiUrl + "var3/fetchByDistrictAndClinicCategory?districtId=" + districtId + "&clinicCategoryId=" + clinicCategoryId + '&period=' + period + '&year=' + year);
}
// public checkWetherAnyAdditionDataIsPendingForVar4ApprovalProcess(stateId, clinicCategoryId) {
//   return this.http.get(this.serviceApiUrl + 'varV1S1/checkWetherAnyAdditionDataIsPendingForVar4ApprovalProcess?stateId=' + stateId + '&clinicCategoryId=' + clinicCategoryId);
// }
public checkWetherAnyAdditionDataIsPendingForVar4ApprovalProcess(stateId, clinicCategoryId, period, year) {
  return this.http.get(this.serviceApiUrl + 'varV1S1/checkWetherAnyAdditionDataIsPendingForVar4ApprovalProcess?stateId=' + stateId + '&clinicCategoryId=' + clinicCategoryId + '&period=' + period + '&year=' + year);
}
// public checkWetherAnyOmissionDataIsPendingForVar4ApprovalProcess(stateId, clinicCategoryId) {
//   return this.http.get(this.serviceApiUrl + 'varV1S2/checkWetherAnyOmissionDataIsPendingForVar4ApprovalProcess?stateId=' + stateId + '&clinicCategoryId=' + clinicCategoryId);
// }
public checkWetherAnyOmissionDataIsPendingForVar4ApprovalProcess(stateId, clinicCategoryId, period, year) {
  return this.http.get(this.serviceApiUrl + 'varV1S2/checkWetherAnyOmissionDataIsPendingForVar4ApprovalProcess?stateId=' + stateId + '&clinicCategoryId=' + clinicCategoryId + '&period=' + period + '&year=' + year);
}

var6locakProcess(clinicCategoryId,year, period) {
  return this.http.get(this.serviceApiUrl + 'Var4and6/checkWhetherClinicCategoryIsPendingInAllVariation?clinicCategoryId=' + clinicCategoryId + '&year=' + year + '&period=' + period );
}
vs1cliniclocakProcess(year, period,clinicCategoryId) {
  return this.http.get(this.serviceApiUrl + 'Var4and6/checkWetherDataExistsForClinicCategoryId?year=' + year + '&period=' + period + '&clinicCategoryId=' + clinicCategoryId );
}

// fetchAllVar4Datas(stateId, clinicCategoryId) {
//   return this.http.get(this.serviceApiUrl + "Var4and6/fetchVar4?stateId=" + stateId + "&clinicCategoryId=" + clinicCategoryId);
// }
fetchAllVar4Datas(stateId, clinicCategoryId, period, year) {
  return this.http.get(this.serviceApiUrl + "Var4and6/fetchVar4?stateId=" + stateId + "&clinicCategoryId=" + clinicCategoryId + '&period=' + period + '&year=' + year);
}
genrateVar4RefNumber(period, year) {
  return this.http.get(this.serviceApiUrl +"Var4and6/generateRef4Number?period=" +period +"&year=" +year,
    { responseType: "text" });
}
findByVar4RefNo(refNO) {
  return this.http.get(this.serviceApiUrl + "Var4and6/fetchByVar4RefNo?refNo=" + refNO);
}
findFileById(id) {
  return this.http.get(this.serviceApiUrl + "file/fetchByFileId?id="+id);
}
fetchVar6Datas(clinicCategoryId, period, year, var6RefNumber) {
  let data = ""
  if (clinicCategoryId != "" && clinicCategoryId != null) {
    data += "clinicCategoryId=" + clinicCategoryId + "&"
  }
  if (period != "" && period != null) {
    data += "period=" + period + "&"
  }
  if (year != "" && year != null) {
    data += "year=" + year + "&"
  }
  if (var6RefNumber != "" && var6RefNumber != null) {
    data += "var6RefNumber=" + var6RefNumber
  }
  return this.http.get(this.serviceApiUrl + "Var4and6/fetchVar6?" + data);
}
genrateVar6RefNumber(period, year) {
  return this.http.get(this.serviceApiUrl +"Var4and6/generateRef6Number?period=" +period +"&year=" + year,
    { responseType: "text" })
}
fetchAllVar6Datas(clinicCategoryId, period, year) {
  let data = ""
  if (clinicCategoryId != "" && clinicCategoryId != null) {
    data += "clinicCategoryId=" + clinicCategoryId + "&"
  }
  if (period != "" && period != null) {
    data += "period=" + period + "&"
  }
  if (year != "" && year != null) {
    data += "year=" + year + "&"
  }
  return this.http.get(this.serviceApiUrl + "Var4and6/fetchVar6ByFilter?" + data);
}
udateApprovalProcessForVAr6(data, file) {
  const formData: FormData = new FormData();
  formData.append("var4and6", JSON.stringify(data));
  formData.append("supportingDocument", file);
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}Var4and6/approveVar6`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
  // return this.http.put(this.serviceApiUrl + "Var4and6/approveVar6",data);
}
fetchVar3FilteredDatas(
  stateId,
  districtId,
  clinicCategoryId,
  variationPeriod,
  year
) {
  let data = "";

  if (stateId != null && stateId != "") {
    data += "stateId=" + stateId + "&";
  }
  if (districtId != null && districtId != "") {
    data += "districtId=" + districtId + "&";
  }
  if (clinicCategoryId != null && clinicCategoryId != "") {
    data += "clinicCategoryId=" + clinicCategoryId + "&";
  }
  if (variationPeriod != null && variationPeriod != "") {
    data += "variationPeriod=" + variationPeriod + "&";
  }
  if (year != null && year != "") {
    data += "year=" + year + "&";
  }
  return this.http.get(
    this.serviceApiUrl + "var3/fetchGroupByFilterList?" + data
  );
}
saveAllVar3(data, file) {
  const formData: FormData = new FormData();
  formData.append("varV1S2", JSON.stringify(data));
  formData.append("supportingDocument", file);
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}var3/updateStatus`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
  // console.log("service post;;;;;", data);
  // return this.http.put(this.serviceApiUrl + "var2/updateStatus", data);
}
public approvalProcessMailVar3(email1, stateId, districtId, clinicCategoryId, variationPeriod, year, var3RefNumber, userId, serviceApiUrl) {
  return this.http.get(this.serviceApiUrl + 'MOHUser/approvalProcessMailVar3?email1=' + email1 + '&stateId=' + stateId + '&districtId=' + districtId + '&clinicCategoryId=' + clinicCategoryId + '&variationPeriod=' + variationPeriod + '&year=' + year + '&var3RefNumber=' + var3RefNumber + '&userId=' + userId + '&serviceApiUrl=' + serviceApiUrl)
}
fetchFilteredVar3Result(
  stateId,
  districtId,
  clinicCategoryId,
  variationPeriod,
  year,
  variation3RefNumber
) {
  if (variation3RefNumber != null && variation3RefNumber != "") {
    return this.http.get(
      this.serviceApiUrl +
      "var3/fetchFilteredVar3Result?stateId=" +
      stateId +
      "&districtId=" +
      districtId +
      "&clinicCategoryId=" +
      clinicCategoryId +
      "&variationPeriod=" +
      variationPeriod +
      "&year=" +
      year
      +
      "&var3RefNo=" +
      variation3RefNumber
    );
  } else {
    return this.http.get(
      this.serviceApiUrl +
      "var3/fetchFilteredVar3Result?stateId=" +
      stateId +
      "&districtId=" +
      districtId +
      "&clinicCategoryId=" +
      clinicCategoryId +
      "&variationPeriod=" +
      variationPeriod +
      "&year=" +
      year
      +
      "&var3RefNo=" +
      null
    );
  }
}
genrateVar3RefNumber(period, year) {
  return this.http.get(this.serviceApiUrl +"var3/generateRefNumber?period=" +period +"&year=" +year);
}
generateVarV1S2RefNo(period, year) {
  return this.http.get(this.serviceApiUrl +"varV1S2/generateRefNumber?period=" +period +"&year=" +year);
}
public checkTheVarLockStatus(districtId, clinicCategoryId, period, year) {
  return this.http.get(this.serviceApiUrl + 'varV1S1/checkTheLockStatus?districtId=' + districtId + '&clinicCategoryId=' + clinicCategoryId + '&period=' + period + '&year=' + year);
}
saveVarV1S1KewpaWithFiles(
  data,
  supportingDocumentMoh,
) {
  const formData: FormData = new FormData();
  formData.append("varV1S2", JSON.stringify(data));
  formData.append("Kewpa15", supportingDocumentMoh);
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}varV1S2/addWithFiles`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
fetchAllVarV1S2() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "varV1S2/allV1S2");
}
fetchAllOmissionData() {
  return this.http.get(this.serviceApiUrl + "varV1S2/all");
}
// public checkWetherDataExistsOnVariation4TableForStateIdAndClinicCatgeoryId(stateId, clinicCategoryId) {
//   return this.http.get(this.serviceApiUrl + 'Var4and6/checkWetherDataExistsForStateIdAndClinicCategoryId?stateId=' + stateId + '&clinicCategoryId=' + clinicCategoryId);
// }
public checkWetherDataExistsOnVariation4TableForStateIdAndClinicCatgeoryId(stateId, clinicCategoryId, period, year) {
  return this.http.get(this.serviceApiUrl + 'Var4and6/checkWetherDataExistsForStateIdAndClinicCategoryId?stateId=' + stateId + '&clinicCategoryId=' + clinicCategoryId + '&period=' + period + '&year=' + year);
}
public checkTheVar3LockStatus(districtId, clinicCategoryId, period, year) {
  return this.http.get(this.serviceApiUrl + 'varV1S2/checkTheLockStatus?districtId=' + districtId + '&clinicCategoryId=' + clinicCategoryId + '&period=' + period + '&year=' + year);
}
fetchAllVarV1S1() {
  return this.http.get<any>(this.serviceApiUrl + "varV1S1/allV1S1");;
}
saveVarV1S1MohWithFiles(
  data,
  supportingDocumentMoh,
) {
  const formData: FormData = new FormData();
  formData.append("varV1S1", JSON.stringify(data));
  formData.append("FileFromMoh", supportingDocumentMoh);
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}varV1S1/addVarVs1AndMohForm`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
generateVarV1S1RefNo(period, year) {
  return this.http.get(this.serviceApiUrl +"varV1S1/generateRefNumber?period=" +period +"&year=" +year);
}
saveVarV1S1WithFiles(
  data,
  formVar1File,
  formEbc1File,
  formKewpaFile,
  formA04RegidtrationFile,
  equipmentPictureFile
) {
  const formData: FormData = new FormData();
  formData.append("varV1S1", JSON.stringify(data));
  formData.append("FormVar1", formVar1File);
  formData.append("FormEBC1", formEbc1File);
  formData.append("FormKewpa", formKewpaFile);
  formData.append("FormA04Registration", formA04RegidtrationFile);
  formData.append("EquipmentPicture", equipmentPictureFile);
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}varV1S1/addWithFiles`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
  return this.http.post(this.serviceApiUrl + "varV1S1/add", data);
}

updateForApproveVar1VS1(data) {
  return this.http.put(this.serviceApiUrl + "varV1S1/update", data);
}
denyForRejectVar1VS1(data) {
  return this.http.put(this.serviceApiUrl + "varV1S1/reject", data);
}
varS1GenerateBeCode(stateCode) {
  return this.http.get(this.serviceApiUrl + "varV1S1/generateBeNumber?stateCode=" + stateCode);
}
saveVarV1S2WithFiles(
  data,
  serviceNotificationFormFile,
  // policeReportFile,
  Kewpa15File,
  // equipmentPictureFile
) {
  const formData: FormData = new FormData();
  formData.append("varV1S2", JSON.stringify(data));
  formData.append("ServiceNotificationForm", serviceNotificationFormFile);
  // formData.append("PoliceReport", policeReportFile);
  formData.append("Kewpa15", Kewpa15File);
  // formData.append("EquipmentPicture", equipmentPictureFile);
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}varV1S2/addWithFiles`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
denyForRejectVar1VS2(data) {
  return this.http.put(this.serviceApiUrl + "varV1S2/reject", data);
}
updateOmissionDatas(data) {
  return this.http.put(this.serviceApiUrl + "varV1S2/update", data)
}

fetchAllVarV1S2ByBeNumber(beNumber) {
  return this.http.post(this.serviceApiUrl + "varV1S2/fetchByBenumber",beNumber);
}
saveVarV1S3S4WithFile(data,file) {
  const formData: FormData = new FormData();
  formData.append("varV1S2", JSON.stringify(data));
  formData.append("VarVS3File", file);
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}varV1S3S4/addWithFiles`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
updateForApproveVarV1S3S4(data) {
  return this.http.put(this.serviceApiUrl + "varV1S3S4/update", data);
}





fetchAllVarV1S3S4() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "varV1S3S4/all");
}
generateVarV1S3RefNo(period, year) {
  return this.http.get(this.serviceApiUrl +"varV1S2/generateRefNumberVs3?period=" +period +"&year=" +year);
}
fetchAllVarV1S4() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "varV1S1/allVs4");
}

fetchAllVar1ClinicCategoryFrom() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "varV1S1/allVs4ChangeClinicCategoryFrom ");
}

fetchAllVar1ClinicCategoryTo() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "varV1S3S4/fetchChangeClinicCategoryTo");
}

updateForsaveVarV1S4withFile(data,file) {
  const formData: FormData = new FormData();
  formData.append("varV1S4", JSON.stringify(data));
  formData.append("VarVS4File", file);
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}varV1S1/updateWithFile`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
generateVarV1S4RefNo(period, year) {
  return this.http.get(this.serviceApiUrl +"varV1S1/generateRefNumberVs4?period=" +period +"&year=" +year);
}
updateRelocationData(data) {
  return this.http.put(this.serviceApiUrl + "varV1S2/update", data)
}
fetchAllVar5Datas(stateId, clinicCatgeoryId, month, year) {
  return this.http.get(this.serviceApiUrl + "Var5/fetchVar5?stateId=" + stateId + "&clinicCategoryId=" + clinicCatgeoryId + "&period=" + month + "&year=" + year);
}
fetchAllVar5FilterDatas(stateId, clinicCategoryId, period, year) {
  let extraUrl = "";
  if (stateId != null && stateId != "") {
    extraUrl += "stateId=" + stateId + "&";
  }
  if (clinicCategoryId != null && clinicCategoryId != "") {
    extraUrl += "clinicCategoryId=" + clinicCategoryId + "&";
  }
  if (period != null && period != "") {
    extraUrl += "period=" + period + "&";
  }
  if (year != null && year != "") {
    extraUrl += "year=" + year + "&";
  }
  // return this.http.get(this.serviceApiUrl + 'var3/fetchGroupByFilterList?'+data);
  return this.http.get(
    this.serviceApiUrl + "Var5/VAr5ByFilterData?" + extraUrl
  );
}
//Internal VAR-Process
fetchAllVs4Internal() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "internalVarV1S4/all");
}
fetchAllVs4InterState() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "interstatetransfervs4/all");
}


generateBeNumberInter(stateCode,assetCategoryCode) {
  console.log(assetCategoryCode);
  console.log(assetCategoryCode != '');
  console.log(assetCategoryCode !=null && assetCategoryCode != '' && assetCategoryCode != undefined);
  
  if(assetCategoryCode.startsWith("#")){
    assetCategoryCode="NAN"
  }

  let dataurl=this.serviceApiUrl + "interstatetransfervs3/generateBeNumber?stateCode="+stateCode

  if( assetCategoryCode !=null && assetCategoryCode != '' && assetCategoryCode != undefined) {
    dataurl+= "&assetCategoryCode=" + assetCategoryCode
  }
  
  return this.http.get<Observable<any>>(dataurl);
  
}
updateForsaveInternalVarV1S4withFile(data,file) {
  const formData: FormData = new FormData();
  formData.append("varV1S4", JSON.stringify(data));
  formData.append("VarVS4File", file);
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}internalVarV1S4/updateWithFile`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}

updateForsaveInterStateVarV1S4withFile(data,file) {
  const formData: FormData = new FormData();
  formData.append("varV1S4", JSON.stringify(data));
  formData.append("VarVS4File", file);
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}interstatetransfervs4/updateWithFile`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
generateInternalVarVs4RefNo() {
  return this.http.get(this.serviceApiUrl +"internalVarV1S4/generateRefNumberVs4");
}

generateInterStateVarVs4RefNo() {
  return this.http.get(this.serviceApiUrl +"interstatetransfervs4/generateRefNumberVs4");
}
saveVarVs3Internal(data,file) {
  const formData: FormData = new FormData();
  formData.append("varV1S2", JSON.stringify(data));
  formData.append("VarVS3File", file);
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}internal_varV1S3/addWithFiles`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
saveVarVs3InterState(data,file) {

  const formData: FormData = new FormData();
  formData.append("varV1S2", JSON.stringify(data));
  formData.append("VarVS3File", file);
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}interstatetransfervs3/addWithFiles`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
updateForApproveVS3Internal(data) {
  return this.http.put(this.serviceApiUrl + "internal_varV1S3/update", data);
}
updateForApproveVS3InterState(data) {
  return this.http.put(this.serviceApiUrl + "interstatetransfervs3/update", data);
}
fetchAllVarVs3internal() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "internal_varV1S3/all");
}
fetchAllVarVs3interState() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "interstatetransfervs3/all");
}
generateInternalVarVs3() {
  return this.http.get(this.serviceApiUrl +"internal_varV1S3/generateRefNumberVs3");
}
generateInterStateVarVs3() {
  return this.http.get(this.serviceApiUrl +"interstatetransfervs3/generateRefNumberVs3");
}
VarInternalDuplicateBeNm(){
  return this.http.get(this.serviceApiUrl +"internalVarV1S2/fetchAll");
}
VarInterStateDuplicateBeNm(){
  return this.http.get(this.serviceApiUrl +"interstatetransfervs3/fetchAll");
}
fetchBeNumbervs2Internal(beNumber) {
  return this.http.get(this.serviceApiUrl + "internalVarV1S2/fetchByBeNumber?beNumber=" +beNumber);
}
fetchBeNumbervs2InterState(beNumber) {
  return this.http.get(this.serviceApiUrl + "interstatetransfervs3/fetchByBeNumber?beNumber=" +beNumber);
}
generateInternalVs2RefNo() {
  return this.http.get(this.serviceApiUrl +"internalVarV1S2/generateRefNumberVs2");
}
saveVarV2InternalWithFile(data,file) {
  const formData: FormData = new FormData();
  formData.append("varV1S2", JSON.stringify(data));
  formData.append("Kewpa15", file);
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}internalVarV1S2/addWithFiles`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
fetchAllVarVs2Internal() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "internalVarV1S2/all");
}
// updateForApproveVS2Internal(data) {
//   return this.http.put(this.serviceApiUrl + "internalVarV1S2/update", data);
// }
ServiceNotificationForm(data,file) {
  const formData: FormData = new FormData();
  formData.append("varV1S2", JSON.stringify(data));
  formData.append("ServiceNotificationForm", file);
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}internalVarV1S2/update`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
rejectForApproveVS2Internal(data) {
  return this.http.put(this.serviceApiUrl + "internalVarV1S2/reject", data);
}
rejectForApproveVS2InterState(data) {
  return this.http.put(this.serviceApiUrl + "interstatetransfervs3/reject", data);
}
getAssetListbyLocationone(  userId,  stateId,  clinicCategoryId,  clinicTypeId,  circleId,  districtId,  clinicId ){
  let data = "";

  if (stateId != null && stateId != "" && stateId !=undefined) {
    data += "stateId=" + stateId + "&";
  }
  if (districtId != null && districtId != "" && districtId !=undefined) {
    data += "districtId=" + districtId + "&";
  }
  if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId !=undefined) {
    data += "clinicCategoryId=" + clinicCategoryId + "&";
  }
  if (userId != null && userId != "" && userId !=undefined) {
    data += "userId=" + userId + "&";
  }
  if (clinicTypeId != null && clinicTypeId != "" && clinicTypeId !=undefined) {
    data += "clinicTypeId=" + clinicTypeId + "&";
  }
  if (circleId != null && circleId != "" && circleId !=undefined) {
    data += "circleId=" + circleId + "&";
  }
  if (clinicId  != null && clinicId  != "" && clinicId  !=undefined) {
    data += "clinicId=" + clinicId  + "&";
  }
  return this.http.get(
    this.serviceApiUrl + "mAsset/beListReport?" + data
  );

  // return this.http.get<Observable<any>>(this.serviceApiUrl + "mAsset/beListReport?stateId=" + stateId + "&userId=" + userId + "&clinicCategoryId=" + clinicCategoryId + "&circleId=" + circleId+"&districtId=" +districtId +"&clinicId="+clinicId+"&clinicTypeId="+clinicTypeId);

}
getAssetListbyBeCategoryone( userId,  workGroupId,  beCategoryId){
  let data = "";

  if (userId != null && userId != "" && userId !=undefined) {
    data += "userId=" + userId + "&";
  }
  if (workGroupId != null && workGroupId != "" && workGroupId !=undefined) {
    data += "workGroupId=" + workGroupId + "&";
  }
  if (beCategoryId != null && beCategoryId != "" && beCategoryId !=undefined) {
    data += "beCategoryId=" + beCategoryId + "&";
  }
  return this.http.get(
    this.serviceApiUrl + "mAsset/beListReport?" + data
  );

  // return this.http.get<Observable<any>>(this.serviceApiUrl + "mAsset/beListReport?userId=" + userId + "&workGroupId=" + workGroupId + "&beCategoryId=" + beCategoryId );

}
getAssetaccessoriesLocation(stateId, districtId, circleId, clinicCategoryId, clinicId, clinicTypeId,userId){
  let data = "";

  if (stateId != null && stateId != "" && stateId !=undefined) {
    data += "stateId=" + stateId + "&";
  }
  if (districtId != null && districtId != "" && districtId !=undefined) {
    data += "districtId=" + districtId + "&";
  }
  if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId !=undefined) {
    data += "clinicCategoryId=" + clinicCategoryId + "&";
  }
  if (userId != null && userId != "" && userId !=undefined) {
    data += "userId=" + userId + "&";
  }
  if (clinicTypeId != null && clinicTypeId != "" && clinicTypeId !=undefined) {
    data += "clinicTypeId=" + clinicTypeId + "&";
  }
  if (circleId != null && circleId != "" && circleId !=undefined) {
    data += "circleId=" + circleId + "&";
  }
  if (clinicId  != null && clinicId  != "" && clinicId  !=undefined) {
    data += "clinicId =" + clinicId  + "&";
  }
 
  return this.http.get(
    this.serviceApiUrl + "mAssetAccessories/beAccessoriesListReport?" + data
  );

  // return this.http.get<Observable<any>>(this.serviceApiUrl + "mAsset/beListReport?stateId=" + stateId + "&userId=" + userId + "&clinicCategoryId=" + clinicCategoryId + "&circleId=" + circleId+"&districtId=" +districtId +"&clinicId="+clinicId+"&clinicTypeId="+clinicTypeId);

}
getAssetaccessoriesbeCategory( userId,  workGroupId,  beCategoryId){
  let data = "";

  if (userId != null && userId != "" && userId !=undefined) {
    data += "userId=" + userId + "&";
  }
  if (workGroupId != null && workGroupId != "" && workGroupId !=undefined) {
    data += "workGroupId=" + workGroupId + "&";
  }
  if (beCategoryId != null && beCategoryId != "" && beCategoryId !=undefined) {
    data += "beCategoryId=" + beCategoryId + "&";
  }
  return this.http.get(
    this.serviceApiUrl + "mAssetAccessories/beAccessoriesListReport?" + data
  );

  // return this.http.get<Observable<any>>(this.serviceApiUrl + "mAsset/beListReport?userId=" + userId + "&workGroupId=" + workGroupId + "&beCategoryId=" + beCategoryId );

}



//  {  let data = "";  if (stateId != null && stateId != "") {    data += "stateId=" + stateId + "&";  }  if (clinicCategoryId != null && clinicCategoryId != "") {    data += "clinicCategoryId=" + clinicCategoryId + "&";  }  if (clinicTypeId != null && clinicTypeId != "") {    data += "clinicTypeId=" + clinicTypeId + "&";  }  if (circleId != null && circleId != "") {    data += "circleId=" + circleId + "&";  }  if (districtId != null && districtId != "") {    data += "districtId=" + districtId + "&";  }  if (clinicId != null && clinicId != "") {    data += "clinicId=" + clinicId + "&";  }   return this.http.get(    this.serviceApiUrl + "mAsset/beListReport?userId="+userId + "&"+ data  );}
//  getAssetListbyBeCategoryone(  userId,  workGroupId,  beCategoryId){  let data = "";  if (workGroupId != null && workGroupId != "") {    data += "workGroupId=" + workGroupId + "&";  }  if (beCategoryId != null && beCategoryId != "") {    data += "beCategoryId=" + beCategoryId + "&";  }  return this.http.get(    this.serviceApiUrl + "mAsset/beListReport?userId="+userId+ "&"+ data  );}
fetchAllVar6StateWiseDatas(clinicCategoryId, period, year) {
  let data = ""
  if (clinicCategoryId != "" && clinicCategoryId != null) {
    data += "clinicCategoryId=" + clinicCategoryId + "&"
  }
  if (period != "" && period != null) {
    data += "period=" + period + "&"
  }
  if (year != "" && year != null) {
    data += "year=" + year + "&"
  }
  return this.http.get(this.serviceApiUrl + "Var4and6/fetch-var6-bystate?" + data);
}
//
var6Lock(clinicCategoryId, period, year){
 
    let data = ""
    if (clinicCategoryId != "" && clinicCategoryId != null) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    if (period != "" && period != null) {
      data += "period=" + period + "&"
    }
    if (year != "" && year != null) {
      data += "year=" + year + "&"
    }
    return this.http.get(this.serviceApiUrl + "Var4and6/checkWeatherDataIsPendingStatusInVar4?" + data);

}
fetchAllVar6DistrictWiseDatas(stateId, clinicCategoryId, period, year) {
  let data = ""
  if (stateId != "" && stateId != null) {
    data += "stateId=" + stateId + "&"
  }
  if (clinicCategoryId != "" && clinicCategoryId != null) {
    data += "clinicCategoryId=" + clinicCategoryId + "&"
  }
  if (period != "" && period != null) {
    data += "period=" + period + "&"
  }
  if (year != "" && year != null) {
    data += "year=" + year + "&"
  }
  return this.http.get(this.serviceApiUrl + "Var4and6/fetchVar4?" + data);
}
generateVar5RefNumber(period,year){
  return this.http.get(this.serviceApiUrl + "Var5/generated-var5-ref-number?period=" +period +"&year=" +year);
}
approveVar5(data){
  return this.http.put(this.serviceApiUrl + "Var5/updateVar5Status",  data);
}
saveConditionalChangeQubics(data){
  return this.http.put(this.serviceApiUrl + "qubicsChanges/saveConditionalChangeForQubics",  data);
}
saveLocationChangeQubics(data){
  return this.http.put(this.serviceApiUrl + "qubicsChanges/saveLocationChangeForQubics",  data);
}
fetchConditionalChangeData(stateId,circleId,districtId,clinicCategoryId,clinicId,conditionalStatusId,page,size,sortBy,sortDirection,searchValue){
  let data = ""
  if (stateId != "" && stateId != null) {
    data += "stateId=" + stateId + "&"
  }
  if (circleId != "" && circleId != null) {
    data += "circleId=" + circleId + "&"
  }
  if (districtId != "" && districtId != null) {
    data += "districtId=" + districtId + "&"
  }
  if (clinicCategoryId != "" && clinicCategoryId != null) {
    data += "clinicCategoryId=" + clinicCategoryId + "&"
  }
  if (clinicId != "" && clinicId != null) {
    data += "clinicId=" + clinicId + "&"
  }
  if (conditionalStatusId != "" && conditionalStatusId != null) {
    data += "conditionalStatusId=" + conditionalStatusId + "&"
  }
  if (page != "" && page != null) {
    data += "page=" + page + "&"
  }
  if (size != "" && size != null) {
    data += "size=" + size + "&"
  }
  if (sortBy != "" && sortBy != null) {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != "" && sortDirection != null) {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != "" && searchValue != null) {
    data += "searchValue=" + searchValue + "&"
  }
  return this.http.get(this.serviceApiUrl + "tsr/beDetailsPagination?" + data);
}
saveConditionalFromActToTsr(data,file){
  const formData: FormData = new FormData();
  formData.append("tsrs", JSON.stringify(data));
  formData.append("file", file);
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}tsr/actToTsr`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
saveConditionalFromTsrToAct(data,file){
  const formData: FormData = new FormData();
  formData.append("tsrs", JSON.stringify(data));
  formData.append("file", file);
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}tsr/tsrToAct`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
fetchAllChangedConditional(){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "tsr/fetchAll")
}
approveConditionalChangeActToTsr(tsrs){
  return this.http.post(this.serviceApiUrl + 'tsr/approveActToTsr', tsrs);
}
approveConditionalChangeTsrToAct(tsrs){
  return this.http.post(this.serviceApiUrl + 'tsr/approveTsrToAct', tsrs);
}
fetchConditionalChangeRefNumber(refNumber){
  return this.http.get(this.serviceApiUrl + "tsr/fetchBeList?refNumber=" +refNumber);
}
generateRefNumberForActToTsrCsc(clinicCategoryId,clinicId){
  return this.http.get(this.serviceApiUrl + "tsr/generateActToTsrRefNumber?clinicCategoryId=" +clinicCategoryId +"&clinicId=" +clinicId)
}
generateRefNumberForTsrToActCsc(clinicCategoryId,clinicId){
  return this.http.get(this.serviceApiUrl + "tsr/generateTsrToActRefNumber?clinicCategoryId=" +clinicCategoryId +"&clinicId=" +clinicId)
}
fetchClinicByStateDistrictCircle(stateId,districtId,circleId){
  return this.http.get(this.serviceApiUrl + "clinic/fetchByStateDistrictClinic?stateId=" +stateId +"&districtId=" +districtId +"&circleId=" +circleId);
   
}
fetchClinicCategory(stateId,districtId,circleId,clinicCategoryId){
  // return this.http.get(this.serviceApiUrl + "clinic/fetchByStateDistrictClinic?stateId=" +stateId +"&districtId=" +districtId +"&circleId=" +circleId+"&clinicCategoryId=" +clinicCategoryId);
  let strUrl = this.serviceApiUrl + "clinic/fetchByStateDistrictClinic?"
  if (stateId) {
    strUrl += "stateId=" + stateId + "&"
  }
  if (circleId) {
    strUrl += "circleId=" + circleId + "&"
  }
  if (districtId) {
    strUrl += "districtId=" + districtId + "&"
  }
  if (clinicCategoryId) {
    strUrl += "clinicCategoryId=" + clinicCategoryId + "&"
  }
  
  return this.http.get<Observable<any>>(strUrl);
}


fetchClinicByStateDistrictCategory(stateId,districtId,circleId,clinicCategoryId){
  // return this.http.get(this.serviceApiUrl + "clinic/fetchByStateDistrictClinic?stateId=" +stateId +"&districtId=" +districtId +"&circleId=" +circleId+"&clinicCategoryId=" +clinicCategoryId);
  let strUrl = this.serviceApiUrl + "clinic/fetchByStateDistrictClinic?"
  if (stateId) {
    strUrl += "stateId=" + stateId + "&"
  }
  if (circleId) {
    strUrl += "circleId=" + circleId + "&"
  }
  if (districtId) {
    strUrl += "districtId=" + districtId + "&"
  }
  if (clinicCategoryId) {
    strUrl += "clinicCategoryId=" + clinicCategoryId + "&"
  }
  
  return this.http.get<Observable<any>>(strUrl);
}


fetchAllLe(){
  return this.http.get(this.serviceApiUrl + "ledetails/all");
}

public saveAssetSecondary(tassetObj,file1:File,fileNamePlate:File,file3:File,file4:File,file5:File,file6:File,file7:File,file8:File,file9:File,file10:File,file11:File,file12:File
  ,file13:File,file14:File,file15:File,file16:File,file17:File,file18:File,file19:File,file20:File,file21:File,file22:File,file23:File){

  const formData: FormData = new FormData();
  formData.append("leDetails",JSON.stringify(tassetObj));
  // file2
  formData.append("FormA04",file23);
  formData.append("EquipmentPicture",file1);
  formData.append("NumberPlatePicture",fileNamePlate);
  formData.append("DeliveryOrder",file3);
  formData.append("BETCChecklist",file4);
  formData.append("TCCertificate",file5);
  formData.append("VarDocuments",file6);
  formData.append("SuratTawaran",file7);
  formData.append("CWStatusPreliminary",file8);
  formData.append("BillOfQuantities",file9);
  formData.append("CWStatusWork",file10);
  formData.append("ApprovedPlan",file11);
  formData.append("CWStatusPostImages",file12);
  formData.append("MethodStatementFile",file13);
  formData.append("CWTCChecklist",file14);
  formData.append("Others",file15);
  formData.append("NCRForm",file16);
  formData.append("DesignConcept",file17);
  formData.append("CPCDocumnet",file18);
  formData.append("DetailedDesign",file19);
  formData.append("ShopDrawings",file20);
  formData.append("SchematicDiagram",file21);
  formData.append("SiteHandoverLetter",file22);



  const req = new HttpRequest('POST', `${this.serviceApiUrl}ledetails/addWithFiles`, formData, {
    reportProgress: true,
    responseType: 'json'
  });

  return this.http.request(req);
  // return this.http.post(this.serviceApiUrl+"assetSecondary/add",tassetObj);

}
public saveAssetSecondaryLE(tassetObj,file1:File,fileNamePlate:File,file3:File,file4:File,file5:File,file6:File,file7:File,file8:File,file9:File,file10:File,file11:File,file12:File
  ,file13:File,file14:File,file15:File,file16:File,file17:File,file18:File,file19:File,file20:File,file21:File,file22:File,file23:File){

  const formData: FormData = new FormData();
  formData.append("leDetails",JSON.stringify(tassetObj));
  // file2
  formData.append("FormA04",file23);
  formData.append("EquipmentPicture",file1);
  formData.append("NumberPlatePicture",fileNamePlate);
  formData.append("DeliveryOrder",file3);
  formData.append("BETCChecklist",file4);
  formData.append("TCCertificate",file5);
  formData.append("VarDocuments",file6);
  formData.append("SuratTawaran",file7);
  formData.append("CWStatusPreliminary",file8);
  formData.append("BillOfQuantities",file9);
  formData.append("CWStatusWork",file10);
  formData.append("ApprovedPlan",file11);
  formData.append("CWStatusPostImages",file12);
  formData.append("MethodStatementFile",file13);
  formData.append("CWTCChecklist",file14);
  formData.append("Others",file15);
  formData.append("NCRForm",file16);
  formData.append("DesignConcept",file17);
  formData.append("CPCDocumnet",file18);
  formData.append("DetailedDesign",file19);
  formData.append("ShopDrawings",file20);
  formData.append("SchematicDiagram",file21);
  formData.append("SiteHandoverLetter",file22);



  const req = new HttpRequest('POST', `${this.serviceApiUrl}ledetails/addWithFiles`, formData, {
    reportProgress: true,
    responseType: 'json'
  });

  return this.http.request(req);
  // return this.http.post(this.serviceApiUrl+"assetSecondary/add",tassetObj);

}
saveCsvFile(csvFile) {
  const formData: FormData = new FormData();
  // formData.append("supplier", JSON.stringify(data));
  formData.append("csvFile", csvFile);
  console.log("service put;;;;;", csvFile);
  // return this.http.put(this.serviceApiUrl + 'm_manufacturer/updateWithFile',data);
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}ledetails/importcsv`,
    formData,
    {
      reportProgress: true,
      responseType: "blob" as "json",
    })
  // return this.http.post(this.serviceApiUrl + "demo/democsv", "csvFile"+csvFile)
  return this.http.request(req);
}
clinicCategoryChangeSave(data,file) {
  const formData: FormData = new FormData();
  formData.append("varV1S2", JSON.stringify(data));
  formData.append("VarVS3File", file);
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}changeClinicCategory/addWithFiles`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}

clinicCategoryVarOneChangeSave(data,file) {
  const formData: FormData = new FormData();
  formData.append("varV1S2", JSON.stringify(data));
  formData.append("VarVS3File", file);
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}varV1S3S4/addWithFilesForChangeClinicCategoryTo`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}

clinicCategoryAotChangeSave(data,file) {
  const formData: FormData = new FormData();
  formData.append("varV1S2", JSON.stringify(data));
  formData.append("VarVS3File", file);
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}internal_varV1S3/addWithFilesForInternalChangeClinicCategoryTo`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}

generateClinicCategoryRefNumber() {
  return this.http.get(this.serviceApiUrl +"changeClinicCategory/generateRefNumber");
}


generateClinicCategoryRefNumberVarOne(period, year) {
  return this.http.get(this.serviceApiUrl +"varV1S2/generateRefNumberVs3?period=" +period +"&year=" +year);
}

generateClinicCategoryRefNumberAot() {
  return this.http.get(this.serviceApiUrl +"internal_varV1S3/generateRefNumberVs3");
}

fetchAllClinicCategoryTransferTo() {
  return this.http.get<Observable<any>>(this.serviceApiUrl +"changeClinicCategory/fetchAll");
}

fetchAllVarOneClinicCategoryTransferTo() {
  return this.http.get<Observable<any>>(this.serviceApiUrl +"varV1S3S4/fetchChangeClinicCategoryTo");
}

fetchAllAotClinicCategoryTransferTo() {
  return this.http.get<Observable<any>>(this.serviceApiUrl +"internal_varV1S3/fetchChangeClinicCategoryTo");
}

rejectForApproveClinicCategoryTransferTo(data) {
  return this.http.put(this.serviceApiUrl + "changeClinicCategory/reject", data);
}

rejectForApproveClinicCategoryTransferToVarOne(data) {
  return this.http.put(this.serviceApiUrl + "varV1S2/reject", data);
}



updateForApproveClinicCategoryTransferToVarOne(data) {
  return this.http.put(this.serviceApiUrl + "varV1S3S4/update", data);
}

updateForApproveClinicCategoryTransferAot(data) {
  return this.http.put(this.serviceApiUrl + "internal_varV1S3/update", data);
}

updateForApproveClinicCategoryTransferTo(data) {
  return this.http.put(this.serviceApiUrl + "changeClinicCategory/update", data);
}
updateForsaveClinicCategoryFromwithFile(data,file) {
  const formData: FormData = new FormData();
  formData.append("varV1S4", JSON.stringify(data));
  formData.append("VarVS4File", file);
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}changeClinicCategoryFrom/updateWithFile`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}

updateForsaveClinicCategoryFromwithFileVarOne(data,file) {
  const formData: FormData = new FormData();
  formData.append("varV1S4", JSON.stringify(data));
  formData.append("VarVS4File", file);
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}varV1S1/updateWithFileChageClinicCategoryFrom`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}

updateForsaveClinicCategoryFromwithFileAot(data,file) {
  const formData: FormData = new FormData();
  formData.append("varV1S4", JSON.stringify(data));
  formData.append("VarVS4File", file);
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}internalVarV1S4/updateWithFileForChangeClinicCategoryFrom`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}

fetchAllClinicCategoryChangeFrom() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "changeClinicCategoryFrom/all");
}

fetchAllClinicCategoryChangeFromVarOne() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "varV1S1/allVs4ChangeClinicCategoryFrom");
}

fetchAllClinicCategoryChangeFromAot() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "internalVarV1S4/allInternalVs4ChangeClinicCategoryFrom");
}

generateClinicCategoryChangeFrom() {
  return this.http.get(this.serviceApiUrl +"changeClinicCategoryFrom/generateRefNumber");
}
fetchBeNumberClinicCategoryChange(beNumber) {
  return this.http.get(this.serviceApiUrl + "changeClinicCategory/fetchByBeNumber?beNumber=" +beNumber);
}
saveCsvFileTe(csvFile) {
  const formData: FormData = new FormData();
  // formData.append("supplier", JSON.stringify(data));
  formData.append("csvFile", csvFile);
  console.log("service put;;;;;", csvFile);
  // return this.http.put(this.serviceApiUrl + 'm_manufacturer/updateWithFile',data);
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}tedetails/importcsv`,
    formData,
    {
      reportProgress: true,
      responseType: "blob" as "json",
    })
  // return this.http.post(this.serviceApiUrl + "demo/democsv", "csvFile"+csvFile)
  return this.http.request(req);
}
fetchAllTe(){
  return this.http.get(this.serviceApiUrl + "tedetails/all");
}
public saveTeAssetSecondary(tassetObj,file1:File,fileNamePlate:File,file3:File,file4:File,file5:File,file6:File,file7:File,file8:File,file9:File,file10:File,file11:File,file12:File
  ,file13:File,file14:File,file15:File,file16:File,file17:File,file18:File,file19:File,file20:File,file21:File,file22:File,file23:File){

  const formData: FormData = new FormData();
  formData.append("leDetails",JSON.stringify(tassetObj));
  // file2
  formData.append("FormA04",file23);
  formData.append("EquipmentPicture",file1);
  formData.append("NumberPlatePicture",fileNamePlate);
  formData.append("DeliveryOrder",file3);
  formData.append("BETCChecklist",file4);
  formData.append("TCCertificate",file5);
  formData.append("VarDocuments",file6);
  formData.append("SuratTawaran",file7);
  formData.append("CWStatusPreliminary",file8);
  formData.append("BillOfQuantities",file9);
  formData.append("CWStatusWork",file10);
  formData.append("ApprovedPlan",file11);
  formData.append("CWStatusPostImages",file12);
  formData.append("MethodStatementFile",file13);
  formData.append("CWTCChecklist",file14);
  formData.append("Others",file15);
  formData.append("NCRForm",file16);
  formData.append("DesignConcept",file17);
  formData.append("CPCDocumnet",file18);
  formData.append("DetailedDesign",file19);
  formData.append("ShopDrawings",file20);
  formData.append("SchematicDiagram",file21);
  formData.append("SiteHandoverLetter",file22);



  const req = new HttpRequest('POST', `${this.serviceApiUrl}tedetails/addWithFiles`, formData, {
    reportProgress: true,
    responseType: 'json'
  });

  return this.http.request(req);
  // return this.http.post(this.serviceApiUrl+"assetSecondary/add",tassetObj);

}
fetchAllNbeExpiryData(){
  return this.http.get(this.serviceApiUrl + "nbeHandOver/fetchNbeAssets");
}
public fetchModifyFilterDatasByBeNumber(beNumber) {
  return this.http.get(this.serviceApiUrl + "asset_modify/fetchByBenumber?beNumber=" + beNumber);
}
public fetchModifyFilterDatasById(id) {
  return this.http.get(this.serviceApiUrl + "asset_modify/findById?id=" +id);
}
saveNbeToEnbe(data){
  return this.http.put(this.serviceApiUrl + "nbeHandOver/update", data);
}
fetchNbeExpiryAssetByFinance(stateId,circleId,districtId,clinicCategoryId,clinicId){
  return this.http.get(this.serviceApiUrl + "nbeHandOver/fetchByFinance?stateId=" +stateId +"&circleId=" +circleId +"&districtId=" +districtId +"&clinicCategoryId=" +clinicCategoryId +"&clinicId=" +clinicId);
}
fetchNbeExpiryAssetByFinanceState(stateId,circleId,districtId,clinicCategoryId,clinicId){
  let data = ""
  if (stateId != null && stateId != "") {
    data += "stateId=" + stateId + "&"
  }
  if (districtId != null && districtId != "") {
    data += "districtId=" + districtId + "&"
  }
  if (circleId != null && circleId != "") {
    data += "circleId=" + circleId + "&"
  }
  if (clinicCategoryId != null && clinicCategoryId != "") {
    data += "clinicCategoryId=" + clinicCategoryId + "&"
  }
  if (clinicId != null && clinicId != "") {
    data += "clinicId=" + clinicId + "&"
  }
return this.http.get<Observable<any>>(this.serviceApiUrl + "nbeHandOver/fetchByFinance?" + data)
}
fetchNbeExpiryAssetByAmdHq(stateId,circleId,districtId,clinicCategoryId,clinicId,year,month){
  return this.http.get(this.serviceApiUrl + "nbeHandOver/fetchByAmdHq?stateId=" +stateId +"&circleId=" +circleId +"&districtId=" +districtId +"&clinicCategoryId=" +clinicCategoryId +"&clinicId=" +clinicId +"&year=" +year+"&month=" +month);
}
saveNbeByFinance(stateId,circleId,districtId,clinicCategoryId,clinicId,data){
   return this.http.post(this.serviceApiUrl + "nbeHandOver/saveDetailsByFinance?stateId=" + stateId + "&circleId=" + circleId + "&districtId=" + districtId + "&clinicCategoryId=" + clinicCategoryId + "&clinicId=" + clinicId, data);
}
getScheduleMaintainancLeBystate(stateId:any){
  return this.http.get(this.serviceApiUrl + "scheduleMaintenanceLe/fetchLeDetailsByState?stateId=" + stateId) 
}

saveScheduleLeDate(data: any) {
  let queryParams = '';

  // Construct query parameters dynamically
  if (data.leScheduleDate1) {
    queryParams += `leScheduleDate1=${data.leScheduleDate1}&`;
  }
  if (data.leScheduleDate2) {
    queryParams += `leScheduleDate2=${data.leScheduleDate2}&`;
  }
  if (data.id) {
    queryParams += `id=${data.id}&`;
  }

  // Remove trailing '&' if it exists
  queryParams = queryParams.endsWith('&') ? queryParams.slice(0, -1) : queryParams;

  const apiUrl = `${this.serviceApiUrl}scheduleMaintenanceLe/updateDetails?${queryParams}`;
  return this.http.get(apiUrl);
}

saveScheduleTableData(userId: string, scheduleData: any[]) {
  const params = new HttpParams().set('userId', userId);
  return this.http.put( this.serviceApiUrl + "scheduleMaintenanceLe/approve", scheduleData, { params });
}

// getScheduleMaintainancLeAll(){
//   return this.http.get(this.serviceApiUrl + "scheduleMaintenanceLe/all") 
// }

getScheduleMaintainancLeAll(stateId?: number): Observable<any> {
  let params = new HttpParams();
  
  if (stateId) {
    params = params.set('stateId', stateId.toString());
  }

  return this.http.get(this.serviceApiUrl + "scheduleMaintenanceLe/all", { params });
}

getscheduleMaintenanceLeSmCount(stateId?:any){
  return this.http.get(this.serviceApiUrl + "scheduleMaintenanceLe/smCounter?stateId=" + stateId) 
}

getscheduleMaintenanceLeSmCountAll(){
  return this.http.get(this.serviceApiUrl + "scheduleMaintenanceLe/smCounter") 
}

fetchLeListFromRefNumberData(stateRefNumber:any){
  return this.http.get(this.serviceApiUrl + "scheduleMaintenanceLe/fetchLeListFromRefNumber?stateRefNumber=" + stateRefNumber) 
}

saveScheduleMaintainancePlaneByGet(data: any) {
  let queryParams = '';

  // Construct query parameters dynamically
  if (data.stateRefNumber) {
    queryParams += `stateRefNumber=${data.stateRefNumber}&`;
  }
  if (data.userId) {
    queryParams += `userId=${data.userId}&`;
  }

  // Remove trailing '&' if it exists
  queryParams = queryParams.endsWith('&') ? queryParams.slice(0, -1) : queryParams;

  const apiUrl = `${this.serviceApiUrl}scheduleMaintenanceLe/sendForApproval?${queryParams}`;
  return this.http.get(apiUrl);
}

currentMonthWiseForPPMData(smUserId?: any) {  // '?' makes it optional
  let url = this.serviceApiUrl + "leWorkOrder/currentMonthWiseForWoPPM";
  if (smUserId) {
    url += "?smUserId=" + smUserId;
  }
  return this.http.get(url);
}

getAllScheduleMaintainDetails(){
  return this.http.get(this.serviceApiUrl + "scheduleMaintenanceTe/all");
}

getAllsmCountDetails(stateId1?: number) {
  const apiUrl = stateId1 
    ? `${this.serviceApiUrl}scheduleMaintenanceTe/smCounter?stateId=${stateId1}` 
    : `${this.serviceApiUrl}scheduleMaintenanceTe/smCounter`;
  return this.http.get(apiUrl);
}

getAllRefrenceBasedDataShowing(refrenceId:number){
  return this.http.get(this.serviceApiUrl + "scheduleMaintenanceTe/fetchLeListFromRefNumber?stateRefNumber=" +refrenceId);
}


fetchValues(userId:any,scheduledetalis:any){
  return this.http.put(this.serviceApiUrl + "scheduleMaintenanceTe/approve?userId=" +userId,scheduledetalis);
}

fetchByData(stateId: number){
  return this.http.get(this.serviceApiUrl + "scheduleMaintenanceTe/fetchLeDetailsByState?stateId=" + stateId)
}

saveSchedulevalues(payload){
 return this.http.get(this.serviceApiUrl + "scheduleMaintenanceTe/updateDetails?calibrationFromDate=" +payload.calibrationDateFrom+ "&calibrationToDate=" +payload.calibrationDateTo+ "&id="+payload.id);
}


scheduleDetailsADD(referencenumber:string,userid:number){
  return this.http.get(this.serviceApiUrl + "scheduleMaintenanceTe/sendForApproval?stateRefNumber=" +referencenumber + "&userId=" +userid);
}

getMonthbasedDataStoring(smUserId){

  let url: string = "teWorkOrder/currentMonthWiseForWoPPM?"
  if (smUserId != null && smUserId != '' && smUserId != undefined) {
    url += "&smUserId=" + smUserId
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + url);
}
downloadGeneratedFormB14B(stateId,circleId,districtId,clinicCategoryId,clinicId,year,month,isSupportingDocument){
  return this.http.get(this.serviceApiUrl + "nbeHandOver/downloadFormB14BAndSupportingDocument?stateId=" +stateId +"&circleId=" +circleId +"&districtId=" +districtId +"&clinicCategoryId=" +clinicCategoryId +"&clinicId=" +clinicId +"&year=" +year+"&month=" +month +"&isSupportingDocument=" +isSupportingDocument);
}
generatedFormB14B(stateId,circleId,districtId,clinicCategoryId,clinicId,year,month){
  return this.http.get(this.serviceApiUrl + "nbeHandOver/generateFormB14B?stateId=" +stateId +"&circleId=" +circleId +"&districtId=" +districtId +"&clinicCategoryId=" +clinicCategoryId +"&clinicId=" +clinicId +"&year=" +year+"&month=" +month);
}
saveNbeByAmdState(stateId,circleId,districtId,clinicCategoryId,clinicId,year,month){
  return this.http.get(this.serviceApiUrl + "nbeHandOver/saveDetailsByAmdState?stateId=" + stateId + "&circleId=" + circleId + "&districtId=" + districtId + "&clinicCategoryId=" + clinicCategoryId + "&clinicId=" + clinicId+ "&year=" + year+ "&month=" + month);
}
generatedFormB14(beNumber,stateId,circleId,districtId,clinicCategoryId,clinicId,year,month){
  return this.http.get(this.serviceApiUrl + "nbeHandOver/generateFormB14?beNumber=" +beNumber +"&stateId=" +stateId +"&circleId=" +circleId +"&districtId=" +districtId +"&clinicCategoryId=" +clinicCategoryId +"&clinicId=" +clinicId +"&year=" +year+"&month=" +month);
}
generatedHandoverCertificate(beNumber,stateId,circleId,districtId,clinicCategoryId,clinicId,year,month){
  return this.http.get(this.serviceApiUrl + "nbeHandOver/generateNbeHandOverCertificateForm?beNumber=" +beNumber +"&stateId=" +stateId +"&circleId=" +circleId +"&districtId=" +districtId +"&clinicCategoryId=" +clinicCategoryId +"&clinicId=" +clinicId +"&year=" +year+"&month=" +month);
}
downloadGeneratedFormB14AndHandoverCertificate(beNumber,stateId,circleId,districtId,clinicCategoryId,clinicId,year,month,isNbeHandOverForm){
  return this.http.get(this.serviceApiUrl + "nbeHandOver/downloadFormB14AndNbeHandOverForm?beNumber=" +beNumber +"&stateId=" +stateId +"&circleId=" +circleId +"&districtId=" +districtId +"&clinicCategoryId=" +clinicCategoryId +"&clinicId=" +clinicId +"&year=" +year+"&month=" +month +"&isNbeHandOverForm=" +isNbeHandOverForm);
}
saveNbeBySM(stateId,circleId,districtId,clinicCategoryId,clinicId,year,month){
  return this.http.get(this.serviceApiUrl + "nbeHandOver/saveDetailsByStateManager?stateId=" + stateId + "&circleId=" + circleId + "&districtId=" + districtId + "&clinicCategoryId=" + clinicCategoryId + "&clinicId=" + clinicId+ "&year=" + year+ "&month=" + month);
}
saveNbeByAmdStateAfterSmApprove(stateId,circleId,districtId,clinicCategoryId,clinicId,year,month,data){
  return this.http.post(this.serviceApiUrl + "nbeHandOver/saveDetailsByAmdStateAfterSM?stateId=" + stateId + "&circleId=" + circleId + "&districtId=" + districtId + "&clinicCategoryId=" + clinicCategoryId + "&clinicId=" + clinicId +"&year=" +year+"&month=" +month, data);
}
saveNbeFilesAmdHqApprove(data,file) {
  const formData: FormData = new FormData();
  formData.append("amdHqData", JSON.stringify(data));
  formData.append("file", file);
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}/nbeHandOver/saveDetailsByAgmHQAfterSM`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
fetchAllAssetsByStateId(stateId) {

  return this.http.get<Observable<any>>(this.serviceApiUrl + "leWorkOrder/findByState?stateId=" + stateId);
}

assignApproveLeWorkOrder(assignLEWorkOrder:any) {
  return this.http.post<Observable<any>>(this.serviceApiUrl + "leWorkOrder/assignLEWorkOrder", assignLEWorkOrder);
}

verifyTheAssignedAssets(data: any) {
  let queryParams = '';

  // Construct query parameters dynamically
  if (data.stateId) {
    queryParams += `stateId=${data.stateId}&`;
  }
  if (data.month) {
    queryParams += `month=${data.month}&`;
  }

  // Remove trailing '&' if it exists
  queryParams = queryParams.endsWith('&') ? queryParams.slice(0, -1) : queryParams;

  const apiUrl = `${this.serviceApiUrl}/leWorkOrder/approveAssigned?${queryParams}`;
  return this.http.get(apiUrl);
}

specLeWoekLoadByState(stateId) {
  let data = ""

  if (stateId != null && stateId != "" && stateId != undefined) {
    data += "stateId=" + stateId + "&"
  }
  return this.http.get(this.serviceApiUrl + 'leWorkOrder/specialistWorkLoadPpmbdm?' + data);
}

fetcLeTechWorkLoad() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "leWorkOrder/technicianWorkLoadPpmbdm");
}

findByLocationLeWorkOrder(month,stateId){
  let urlString: string =  "leWorkOrder/filterByLocation?month="+month
  if(stateId != null && stateId!='' && stateId != 0 ){
    urlString +="&stateId=" + stateId
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}


// findByLocationLeWorkOrder(data: any) {
//   let queryParams = '';

//   // Construct query parameters dynamically
//   if (data.stateId) {
//     queryParams += `stateId=${data.stateId}&`;
//   }
//   if (data.month) {
//     queryParams += `month=${data.month}&`;
//   }

//   // Remove trailing '&' if it exists
//   queryParams = queryParams.endsWith('&') ? queryParams.slice(0, -1) : queryParams;

//   // const apiUrl = `${this.serviceApiUrl}/leWorkOrder/approveAssigned?${queryParams}`;
//   const apiUrl = `${this.serviceApiUrl}/leWorkOrder/filterByLocation?${queryParams}`;
//   return this.http.get(apiUrl);
// }

findByCategoryLeWorkOrder(data: any) {
  let queryParams = '';

  // Construct query parameters dynamically
  if (data.month) {
    queryParams += `month=${data.month}&`;
  }

  if (data.workGroupId) {
    queryParams += `workGroupId=${data.workGroupId}&`;
  }

  if (data.beCategoryId) {
    queryParams += `beCategoryId=${data.beCategoryId}&`;
  }

  if (data.stateId) {
    queryParams += `stateId=${data.stateId}&`;
  }
  // Remove trailing '&' if it exists
  queryParams = queryParams.endsWith('&') ? queryParams.slice(0, -1) : queryParams;

  // const apiUrl = `${this.serviceApiUrl}/leWorkOrder/approveAssigned?${queryParams}`;
  const apiUrl = `${this.serviceApiUrl}/leWorkOrder/filterByCategory?${queryParams}`;
  return this.http.get(apiUrl);
}
beCategorybasedataPassing(month,stateId,becategoryId){
  let urlString: string = "month=" + month;
  if (stateId != null && stateId != '' && stateId != undefined) {
    urlString += "&stateId=" + stateId
  }
  if (becategoryId != null && becategoryId != '' && becategoryId != undefined) {
    urlString += "&beCategoryId=" + becategoryId
  }

  return this.http.get<Observable<any>>(this.serviceApiUrl + "teWorkOrder/filterByCategory?" + urlString);
}



specloadByState(stateId){
 let data = ""
  if(stateId !=null && stateId !="" && stateId !=undefined){
    data += "stateId=" + stateId + "&"
  }
  return this.http.get(this.serviceApiUrl + "teWorkOrder/specialistWorkLoadPpmbdm?" + data);
}
statebasedData(month,stateId){
  let urlString: string =  "teWorkOrder/filterByLocation?month="+month
  if(stateId != null && stateId!='' && stateId != 0 ){
    urlString +="&stateId=" + stateId
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}
workOrderExcel(stateId,circleId,month,year){
  let urlString = "teWorkOrder/woGenerationExcelDetails?"
  if (stateId != null && stateId != '' && stateId != 0) {
    urlString += "&stateId=" + stateId
  }
  if (circleId != null && circleId != '' && circleId != 0) {
    urlString += "&circleId=" + circleId
  }
  if (month != null && month != '') {
    urlString += "&month=" + month
  }
  if (year != null && year != '') {
    urlString += "&year=" + year
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}
findCategory(assetCategoryId, stateId){
   let urlString: string = "assetCategoryId=" + assetCategoryId
   if (stateId != null && stateId != '' && stateId != undefined) {
    urlString += "&stateId=" + stateId
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + "teWorkOrder/findByCategory?" + urlString);
}
fetchAllLeWorkRequestWorkOrderPagination(tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue) {
  let data = ""
  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrderPagination?tabSetStatus=woNotAcknowledged&userId=" + userId+"&page="+page +"&size="+size+"&sortBy="+sortBy);
  return this.http.get<Observable<any>>(this.serviceApiUrl + "leWorkOrder/fetchWorkRequestWorkOrderPagination?" + data) ;
}



getByWrunAssignedByLeId(id) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "leWorkOrder/id?id=" + id)
}

approveTechWorkOrderLe(data) {
  return this.http.put(this.serviceApiUrl + "leWorkOrder/approve", data)
}

rejectTechWRunAssignedLe(data) {
  return this.http.put<Observable<any>>(this.serviceApiUrl + "leWorkOrder/reject", data);
}

specLoadByStatete(stateId){
  let data = ""

  if (stateId != null && stateId != "" && stateId != undefined) {
    data += "stateId=" + stateId + "&"
  }
  return this.http.get(this.serviceApiUrl + 'teWorkOrder/specialistWorkLoadPpmbdm?' + data);
}

specLoadByState(stateId) {
  let data = ""

  if (stateId != null && stateId != "" && stateId != undefined) {
    data += "stateId=" + stateId + "&"
  }
  return this.http.get(this.serviceApiUrl + 'smWorkOrder/specialistWorkLoadPpmbdm?' + data);
}

fetcLeInprogressSorting(tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue,isHighlighted) {
  let data = ""
  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  if (isHighlighted != null && isHighlighted != "") {
    data += "isHighlighted=" + isHighlighted 
  }
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrderPagination?tabSetStatus=woNotAcknowledged&userId=" + userId+"&page="+page +"&size="+size+"&sortBy="+sortBy);
  return this.http.get<Observable<any>>(this.serviceApiUrl + "leWorkOrder/sortByColorLE?" + data) ;
}

createMRraiseLe(
  data,
  file,
) {
  const formData: FormData = new FormData();
  formData.append("workRequestData", JSON.stringify(data));
  formData.append("file", file);
  console.log('goes', file)
  // const req = new HttpRequest(
  //   "POST",
  //   `${this.serviceApiUrl}/smWorkOrder/raiseMR`,
  //   formData,
  //   {
  //     reportProgress: true,
  //     responseType: "json",
  //   }
  // );
  // return this.http.post(req);
  return this.http.post(this.serviceApiUrl + "leWorkOrder/raiseMR", formData);
}

fetchLeRefactorMR(id) {
  return this.http.get(this.serviceApiUrl + "mrworkOrder/findAllLEWorkOrder?id=" + id)
}

savePendingCompletionFilesLe(
  data,
  file1,
  file2,
  file3,
) {
  const formData: FormData = new FormData();
  formData.append("workRequestStringObj", JSON.stringify(data));
  formData.append("checkList", file2);
  formData.append("electricityReportFile", file3);
  formData.append("file3", file1);
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}leWorkOrder/approveWithFile`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}

otrRequestLe(data) {
  return this.http.put(this.serviceApiUrl + "leWorkOrder/otrRaise", data);
}

otrRequestTe(data) {
  return this.http.put(this.serviceApiUrl + "teWorkOrder/otrRaise", data);
}
fetchAllTeCount(userId, stateId, circleId, districtId, clinicId){
  let strUrl = this.serviceApiUrl + "teWorkOrder/fetchCountWorkOrder?"
  if (stateId) {
    strUrl += "stateId=" + stateId + "&"
  }
  if (circleId) {
    strUrl += "circleId=" + circleId + "&"
  }
  if (districtId) {
    strUrl += "districtId=" + districtId + "&"
  }
  if (clinicId) {
    strUrl += "clinicId=" + clinicId + "&"
  }
  if (userId) {
    strUrl += "userId=" + userId + "&"
  }
  return this.http.get<Observable<any>>(strUrl);
}


fetchAllTech(tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue){
  let data = ""
  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + "teWorkOrder/fetchWorkRequestWorkOrderPagination?" + data);
}

fetchDataByIdPPm(id){
  return this.http.get<Observable<any>>(this.serviceApiUrl + 'teWorkOrder/id?id=' + id)
}

approveTechWorkOrder(data){
  return this.http.put(this.serviceApiUrl + "teWorkOrder/approve", data)
}

rejectTechWRunAssigned(data){
  return this.http.put<Observable<any>>(this.serviceApiUrl + "teWorkOrder/reject", data);
}

getByWrunAssignedByPPMId(id){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "teWorkOrder/id?id=" + id)
}

savePendingCompletionFiles(data,file1,file2,file3){
   const formData : FormData = new FormData();
   formData.append("workRequestStringObj", JSON.stringify(data));
   formData.append("checkList", file2);
   formData.append("electricityReportFile", file3);
   formData.append("file3", file1);
   const req = new HttpRequest(
    "PUT", 
    `${this.serviceApiUrl}/teWorkOrder/approveWithFile`,
    formData,{
      reportProgress: true,
      responseType: "json",
    }
   );
   return this.http.request(req);
}
fetchRefactorMR(id){
  return this.http.get(this.serviceApiUrl + "mrworkOrder/findAllTEWorkOrder?id=" + id);
}
fetchPpmRefactorMR(id){
  return this.http.get(this.serviceApiUrl + "mrworkOrder/findAllTEWorkOrder=" +id);
}
createraisePPm(data,file){
  const formData: FormData = new FormData();
  formData.append("workRequestData", JSON.stringify(data));
  formData.append("file", file);
  console.log('goes', file)
  return this.http.post(this.serviceApiUrl + "teWorkOrder/raiseMR", formData);
}
otrRequest(data){
 return this.http.put(this.serviceApiUrl + "teWorkOrder/otrRaise", data);
}



fetchPPMMInprogressSorting(tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue,isHighlighted){
  let data = ""
  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  if (isHighlighted != null && isHighlighted != "") {
    data += "isHighlighted=" + isHighlighted 
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + "teWorkOrder/sortByColorTE?" + data) ;
}
notificationfindCircleIncharge(circleId) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "notificationview/findCircleIncharge?circleId=" + circleId)


}
notificationAddAll(data) {
  return this.http.post<Observable<any>>(this.serviceApiUrl + "notificationview/addAll", data)

}
fetchNbeExpiryAssetByAmdHqApprove(stateId,circleId,districtId,clinicCategoryId,clinicId,year,month){
  return this.http.get(this.serviceApiUrl + "nbeHandOver/fetchByAmdHqAfterSM?stateId=" +stateId +"&circleId=" +circleId +"&districtId=" +districtId +"&clinicCategoryId=" +clinicCategoryId +"&clinicId=" +clinicId +"&year=" +year+"&month=" +month);
}

// bdm apis from here  

fetchByStateIdConcat(stateId){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "leBreakdownController/findAccessoriesByClinicIdCombined?stateId=" + stateId);
}

fetchPendingWObyLenumber(leNumber) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "leBreakdownController/fetchPendingWorkOrdersByBenumber?leNumber=" + leNumber);
}

fetchByLeNumberConcat(leNumber){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "leBreakdownController/fetchBeNumberDetailsNew?leNumber=" + leNumber);

}

addWRUnAssigned(workRequest) {
  return this.http.post<Observable<any>>(this.serviceApiUrl + "leBreakdownController/add", workRequest);
}

// 

fetchAllLeBdmWorkRequestWorkOrderPagination(stateId?:any,tabSetStatus?:any,userId?:any,page?:any,size?:any,sortBy?:any,sortDirection?:any,searchValue?:any) {
  let data = ""
  if (stateId != null && stateId != "") {
    data += "stateId=" + stateId + "&"
  }
  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrderPagination?tabSetStatus=woNotAcknowledged&userId=" + userId+"&page="+page +"&size="+size+"&sortBy="+sortBy);
  return this.http.get<Observable<any>>(this.serviceApiUrl + "leBreakdownController/fetchWorkRequestWorkOrderPagination?" + data) ;
}


fetchAllLeBdmWorkRequestWorkOrderPaginationTe(stateId?:any,tabSetStatus?:any,userId?:any,page?:any,size?:any,sortBy?:any,sortDirection?:any,searchValue?:any) {
  let data = ""
  if (stateId != null && stateId != "") {
    data += "stateId=" + stateId + "&"
  }
  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrderPagination?tabSetStatus=woNotAcknowledged&userId=" + userId+"&page="+page +"&size="+size+"&sortBy="+sortBy);
  return this.http.get<Observable<any>>(this.serviceApiUrl + "teBreakdownController/fetchWorkRequestWorkOrderPagination?" + data) ;
}


fetchAllLeBdmWRUnAssignedByFilter(tabSetStatus,stateId) {
  let data = ""

  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (stateId != null && stateId != "") {
    data += "stateId=" + stateId 
  }
  
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/wrUnassignedByFilter?" + data);
  return this.http.get<Observable<any>>(this.serviceApiUrl + "leBreakdownController/fetchWorkRequestWorkOrder?" + data);
}

fetchAllWoCount(userId, stateId, circleId, districtId, clinicId,) {
  let strUrl = this.serviceApiUrl + "leBreakdownController/fetchCountWorkOrder?"

  if (stateId) {
    strUrl += "stateId=" + stateId + "&"
  }
  if (circleId) {
    strUrl += "circleId=" + circleId + "&"
  }
  if (districtId) {
    strUrl += "districtId=" + districtId + "&"
  }
  if (clinicId) {
    strUrl += "clinicId=" + clinicId + "&"
  }
  if (userId) {
    strUrl += "userId=" + userId + "&"
  }
  return this.http.get<Observable<any>>(strUrl);
}
// checkHoliday(leId: number, scheduledDate: string): Observable<any> {
//   return this.http.get<any>(`${this.apiUrl}?leId=${leId}&scheduledDate=${scheduledDate}`);
// }
checkHolidayLe(leId: number, scheduledDate: string) {
  return this.http.get(this.serviceApiUrl + 'scheduleMaintenanceLe/checkHoliday?leId=' + leId + '&scheduledDate=' + scheduledDate)
}

getByWrunAssignedById(id, status) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "leBreakdownController/id?id=" + id + "&tabSetStatus=" + status)
}

getByWrunAssignedByIdTe(id, status) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "teBreakdownController/id?id=" + id + "&tabSetStatus=" + status)
}

specLoadByStateLeBdm(stateId) {
  let data = ""

  if (stateId != null && stateId != "" && stateId != undefined) {
    data += "stateId=" + stateId + "&"
  }
  return this.http.get(this.serviceApiUrl + 'leWorkOrder/specialistWorkLoadPpmbdm?' + data);
}

specLoadByStateTeBdm(stateId) {
  let data = ""

  if (stateId != null && stateId != "" && stateId != undefined) {
    data += "stateId=" + stateId + "&"
  }
  return this.http.get(this.serviceApiUrl + 'teWorkOrder/specialistWorkLoadPpmbdm?' + data);
}

fetchByPreviousPbrHis(problemReportedId) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "leBreakdownController/historyProblems?problemReportedId=" + problemReportedId)
}

fetchByPreviousPbrHisTe(problemReportedId) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "teBreakdownController/historyProblems?problemReportedId=" + problemReportedId)
}

approveWorkOrder(data) {
  return this.http.put(this.serviceApiUrl + "leBreakdownController/approve", data);
}

approveWorkOrderTe(data) {
  return this.http.put(this.serviceApiUrl + "teBreakdownController/approve", data);
}

rejectWRunAssigned(data) {
  return this.http.put<Observable<any>>(this.serviceApiUrl + "leBreakdownController/reject", data);
}

rejectWRunAssignedTe(data) {
  return this.http.put<Observable<any>>(this.serviceApiUrl + "teBreakdownController/reject", data);
}

fetchAllBdmWithPagination(tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue,year,month) {
  let data = ""
  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  if (year != null && year != "") {
    data += "year=" + year + "&"
  }
  if (month != null && month != "") {
    data += "month=" + month + "&"
  }
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrderPagination?tabSetStatus=woNotAcknowledged&userId=" + userId+"&page="+page +"&size="+size+"&sortBy="+sortBy);
  return this.http.get<Observable<any>>(this.serviceApiUrl + "leBreakdownController/fetchWorkRequestWorkOrderPagination?" + data) ;
}

fetchAllBdmWithPaginationTe(tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue,year,month) {
  let data = ""
  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  if (year != null && year != "") {
    data += "year=" + year + "&"
  }
  if (month != null && month != "") {
    data += "month=" + month + "&"
  }
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrderPagination?tabSetStatus=woNotAcknowledged&userId=" + userId+"&page="+page +"&size="+size+"&sortBy="+sortBy);
  return this.http.get<Observable<any>>(this.serviceApiUrl + "teBreakdownController/fetchWorkRequestWorkOrderPagination?" + data) ;
}

fetchBDMInprogressSorting(tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue,isHighlighted) {
  let data = ""
  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  if (isHighlighted != null && isHighlighted != "") {
    data += "isHighlighted=" + isHighlighted 
  }
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrderPagination?tabSetStatus=woNotAcknowledged&userId=" + userId+"&page="+page +"&size="+size+"&sortBy="+sortBy);
  return this.http.get<Observable<any>>(this.serviceApiUrl + "leBreakdownController/sortByColor?" + data) ;
}

fetchBDMInprogressSortingTe(tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue,isHighlighted) {
  let data = ""
  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  if (isHighlighted != null && isHighlighted != "") {
    data += "isHighlighted=" + isHighlighted 
  }
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrderPagination?tabSetStatus=woNotAcknowledged&userId=" + userId+"&page="+page +"&size="+size+"&sortBy="+sortBy);
  return this.http.get<Observable<any>>(this.serviceApiUrl + "teBreakdownController/sortByColor?" + data) ;
}


saveBreakDownPendingCompletionFiles(
  data,
  serviceNotificationFormFile,
  policeReportFile,
  Kewpa15File,
) {
  const formData: FormData = new FormData();
  formData.append("workRequestStringObj", JSON.stringify(data));
  formData.append("checkList", serviceNotificationFormFile);
  formData.append("electricityReportFile", Kewpa15File);
  formData.append("file3", policeReportFile);
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}leBreakdownController/approveWithFile`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}

saveBreakDownPendingCompletionFilesTe(
  data,
  serviceNotificationFormFile,
  policeReportFile,
  Kewpa15File,
) {
  const formData: FormData = new FormData();
  formData.append("workRequestStringObj", JSON.stringify(data));
  formData.append("checkList", serviceNotificationFormFile);
  formData.append("electricityReportFile", Kewpa15File);
  formData.append("file3", policeReportFile);
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}teBreakdownController/approveWithFile`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}

// Te Workorder apis are start form below

fetchAllWoCountTe(userId, stateId, circleId, districtId, clinicId,) {
  let strUrl = this.serviceApiUrl + "teBreakdownController/fetchCountWorkOrder?"

  if (stateId) {
    strUrl += "stateId=" + stateId + "&"
  }
  if (circleId) {
    strUrl += "circleId=" + circleId + "&"
  }
  if (districtId) {
    strUrl += "districtId=" + districtId + "&"
  }
  if (clinicId) {
    strUrl += "clinicId=" + clinicId + "&"
  }
  if (userId) {
    strUrl += "userId=" + userId + "&"
  }
  return this.http.get<Observable<any>>(strUrl);
}

createMRraise(
  data,
  file,
) {
  const formData: FormData = new FormData();
  formData.append("workRequestData", JSON.stringify(data));
  formData.append("file", file);
  console.log('goes', file)
  // const req = new HttpRequest(
  //   "POST",
  //   `${this.serviceApiUrl}/smWorkOrder/raiseMR`,
  //   formData,
  //   {
  //     reportProgress: true,
  //     responseType: "json",
  //   }
  // );
  // return this.http.post(req);
  return this.http.post(this.serviceApiUrl + "leBreakdownController/raiseMR", formData);
}

createMRraiseTe(
  data,
  file,
) {
  const formData: FormData = new FormData();
  formData.append("workRequestData", JSON.stringify(data));
  formData.append("file", file);
  console.log('goes', file)
  // const req = new HttpRequest(
  //   "POST",
  //   `${this.serviceApiUrl}/smWorkOrder/raiseMR`,
  //   formData,
  //   {
  //     reportProgress: true,
  //     responseType: "json",
  //   }
  // );
  // return this.http.post(req);
  return this.http.post(this.serviceApiUrl + "teBreakdownController/raiseMR", formData);
}

stockTransactionsByBeNumber(leNumber) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "leBreakdownController/stockTransactionsByBeNumber?leNumber=" + leNumber)
}

stockTransactionsByBeNumberTe(teNumber) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "teBreakdownController/stockTransactionsByBeNumber?leNumber=" + teNumber)
}

transactionFetchByStockCode(stockCode) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "leBreakdownController/recentTransactions?stockCode=" + stockCode)
}

transactionFetchByStockCodeTe(stockCode) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "teBreakdownController/recentTransactions?stockCode=" + stockCode)
}

approveCloseMRBreakdown(data) {
  return this.http.put(this.serviceApiUrl + "leBreakdownController/approve", data)
}

approveCloseMRBreakdownTe(data) {
  return this.http.put(this.serviceApiUrl + "teBreakdownController/approve", data)
}




}
